export enum RailTypeEnum {
  TopRail,
  BottomRail
}
